import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { SiLeetcode, SiHackerrank } from 'react-icons/si';

const SocialLinks = () => {
    return (
        <div className="social-links-container" role="complementary" aria-label="Social media links">
            <a href="https://github.com/Vigneshmunikannan" target="_blank" rel="noopener noreferrer" aria-label="Visit GitHub profile">
                <FaGithub className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/in/vignesh-m-25909b237" target="_blank" rel="noopener noreferrer" aria-label="Visit LinkedIn profile">
                <FaLinkedin className="social-icon" />
            </a>
            <a href="https://leetcode.com/u/vigneshmunikannan/" target="_blank" rel="noopener noreferrer" aria-label="Visit LeetCode profile">
                <SiLeetcode className="social-icon" />
            </a>
            <a href="https://www.hackerrank.com/profile/vigneshmunikann1" target="_blank" rel="noopener noreferrer" aria-label="Visit HackerRank profile">
                <SiHackerrank className="social-icon" />
            </a>
            <a href="mailto:vigneshmunikannan@gmail.com" aria-label="Send email">
                <FaEnvelope className="social-icon" />
            </a>
        </div>
    );
};

export default SocialLinks;
